module.exports = __webpack_public_path__ + "img/chatbot5.5f19b7fb.svg";